import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { applikasi } from './application.module';
import { news } from './news.module';
import { Slider } from './slider.module';
import { Appmenu } from './appmenu.module';
import { Reseller } from './reseller.module';
import { mitra } from './mitraserver.module';
import { Product } from './product.module';
import { Popup } from './popup.module';
import {RunningText} from "@/store/runningtext.module";
import { Breakpoins } from "@/store/breakpoints";
import { authentication } from "@/store/auth.store";
import { UploadImage } from "@/store/uploadimage.store";
import { TokenSMS } from "@/store/tokensms.module";
import  { Dashboard } from "@/store/dashboard.module";
import  { TopupChannel } from "@/store/topupchannel.module";
import { Wallet } from "@/store/wallet.store";
import { Bayartempo } from "@/store/modalKerja.store";
import {Loan} from "@/store/capital.module"
import { Location } from "@/store/location.module";
import { Kategori } from "@/store/kategori.module";
import { DeleteAkun } from "@/store/deleteakun.store"
import { Digipos } from "@/store/digipos.module"
import { Isimple } from "@/store/isimple.module"
import { Sidompul } from "@/store/sidompul.module"

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        alert,
        account,
        applikasi,
        news,
        Slider,
        Appmenu,
        Reseller,
        mitra,
        Product,
        Popup,
        RunningText,
        Breakpoins,
        authentication,
        UploadImage,
        TokenSMS,
        Dashboard,
        TopupChannel,
        Wallet,
        Loan,
        Location,
        Kategori,
        Bayartempo,
        DeleteAkun,
        Digipos,
        Isimple,
        Sidompul
    }
});
